import Link from "next/link";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { FC } from "react";
import { SearchProduct } from "@/app/lib/features/search/search.types";
import { getSoftBadgeStyle } from "@/app/utils/badgeColors";
import Image from "next/image";
import { trackProductClick } from "@/app/lib/tracking/interactions";

interface HorizontalProductCardProps {
  product: SearchProduct;
  onClose?: () => void;
}

const HorizontalProductCard: FC<HorizontalProductCardProps> = ({
  product,
  onClose,
}) => {
  return (
    <Link
      href={`/${product.slug}`}
      onClick={() => { trackProductClick(product.id); onClose?.(); }}
      className="group/card bg-white hover:bg-gray-50 border border-gray-200 hover:border-main hover:shadow-md transition-all duration-300 ease-in-out rounded-lg p-1.5 sm:p-2 flex gap-2 sm:gap-3"
    >
      <div className="relative w-12 h-16 sm:w-16 sm:h-20 md:w-20 md:h-24 shrink-0 rounded-lg overflow-hidden bg-white">
        <FallbackImage
          src={product.first_image}
          alt={product.internet_product_description}
          fill
          className="object-contain group-hover/card:scale-[1.02] transition-all duration-300 ease-in-out"
          fallbackClassName="object-contain opacity-60"
          sizes="(max-width: 640px) 48px, (max-width: 768px) 64px, 80px"
          quality={70}
        />
      </div>
      <div className="flex-1 min-w-0 space-y-1 sm:space-y-2">
        <p className="text-[9px] sm:text-xs md:text-sm text-gray-600 line-clamp-2 leading-3 sm:leading-4">
          <span className="text-[10px] sm:text-xs md:text-sm font-semibold text-gray-900">
            {product.seller.name}
          </span>{" "}
          {product.internet_product_description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-[10px] sm:text-xs md:text-sm font-bold text-main">
            {product.price}
          </span>
        </div>
        <div className="flex items-center gap-0.5 sm:gap-1 flex-wrap">
          {product.badges.map((badge, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1 px-1.5 sm:px-2 py-0.5 rounded-md text-[8px] sm:text-[10px] font-medium"
              style={getSoftBadgeStyle(badge.color_hex)}
            >
              {badge.icon_full && (
                <Image
                  src={badge.icon_full}
                  alt={badge.label}
                  width={10}
                  height={10}
                  className="shrink-0"
                />
              )}
              {badge.label}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default HorizontalProductCard;
